import { v1 as uuid } from 'uuid';

const getRoomModel = () => ({
  key: uuid(),
  passengers: []
});

const getPassengerModel = () => ({
  key: uuid()
});

export {
  getRoomModel,
  getPassengerModel
};